import CryptoJS from 'crypto-js';

const secretKey = 'TaxLowPricesSecretKey2026';
const key = CryptoJS.enc.Utf8.parse(secretKey);
const iv = '1234567890123456'; // 16 bytes IV for AES

export const encryptPassword = (password) => {
    const textoCifrado = 
    CryptoJS.AES.encrypt(password, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return textoCifrado.toString();
}

export const decryptPassword = (encryptedPassword) => {
    const bytes = CryptoJS.AES.decrypt(encryptedPassword, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return bytes.toString(CryptoJS.enc.Utf8);
}

export const encryptString = (string) => {
    const textoCifrado = 
    CryptoJS.AES.encrypt(string, secretKey, {
        iv: iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return textoCifrado.toString();
}

export const decryptString = (encryptedString) => {
    //console.log(encryptedString);
    const decrypted = 
    CryptoJS.AES.decrypt(encryptedString, secretKey
    , { 
        iv: iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}